import {
  ContractorPortalLogout,
  ContractorPortalFetchCertificates,
} from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { ContractorPortalCertificatesState } from './types'

const getInitialState = (): ContractorPortalCertificatesState => ({
  contractorPortalCertificates: [],
  contractorPortalCertificatesCount: 0,
})

export const contractorPortalCertificatesReducer = (
  state: ContractorPortalCertificatesState = getInitialState(),
  action: Action<any>,
): ContractorPortalCertificatesState => {
  switch (action.type) {
    case ContractorPortalFetchCertificates.type.SUCCESS:
      return {
        ...state,
        contractorPortalCertificates: action.payload,
        contractorPortalCertificatesCount: action.payload.length,
      }
    case ContractorPortalLogout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
